import React from 'react';

import { InputAdornment, FormControl, OutlinedInput, InputLabel } from '@mui/material';
import KeywordToolTip from 'src/components/keyword-tooltip';
import { PercentFormat } from './NumericFormatCustom';

// Function to format a percentage value for display as a whole number
const formatPercentage = (value, scalar = 1) => value * scalar;
// Function to parse a formatted percentage and return the scaled value
const parsePercentage = (formattedValue, scalar = 1) => formattedValue / scalar;
export const PercentField = ({
  value,
  placeholder,
  label,
  handleFocus,
  stepSize,
  onChange,
  valueOffset = 0,
  monthly = false,
  yearly = false,
  name,
  scaler,
  sx,
  ...other
}) => (
  <FormControl {...other}>
    <InputLabel id="type-label">
      <KeywordToolTip keyword={label} />
    </InputLabel>

    <OutlinedInput
      sx={sx}
      onFocus={handleFocus}
      inputComponent={PercentFormat}
      name={name}
      defaultValue=""
      inputProps={{
        step: stepSize?.toString(),
        onWheel: (e) => e.target.blur(),
      }}
      label={<KeywordToolTip keyword={label} />}
      startAdornment={<InputAdornment position="start">%</InputAdornment>}
      endAdornment={
        (monthly || yearly) && (
          <InputAdornment position="end">/ {monthly ? 'month' : 'year'}</InputAdornment>
        )
      }
      placeholder={formatPercentage(placeholder - valueOffset, scaler).toFixed(2) ?? label}
      value={value ? formatPercentage(value - valueOffset, scaler) : value ?? ''}
      onChange={(e) => {
        let scaledValue = parsePercentage(parseFloat(e.target.value), scaler) + valueOffset;
        if (Number.isNaN(scaledValue)) scaledValue = null;
        e.target.value = scaledValue;
        onChange(e);
      }}
      {...{ ...other }}
    />
  </FormControl>
);
